import { lazy } from 'react';
import { t } from 'i18next';
import {
  CompanyInfoScreen,
  DashboardAnalyzeDocuments,
  DashboardRegisteringBusinessPage,
  DashboardRegisteringCompanyPage,
  DashboardRegisteringDirectorsPage,
  DashboardRegisteringShareholdersPage,
  EnquiryScreen
} from '../pages/DashboardCustomer';
import { CompaniesStatisticsScreen } from '../pages/DashboardManagement/CompaniesStatisticsScreen';
import { CompanyDetailsScreen } from '../pages/DashboardManagement/CompanyDetailsScreen';
import { DashboardCompaniesScreen } from '../pages/DashboardManagement/DashboardCompaniesScreen';
import { SpecialistsScreen } from '../pages/DashboardManagement/SpecialistsScreen';
import { EnvironmentSetupScreen } from '../pages/DashboardOffice/EnvironmentSetup';
import { DashboardPaymentStatus } from '../pages/DashboardOffice/DashboardPaymentStatus/index';

const DashboardHomeUsers = lazy(() => import('../pages/DashboardCustomer/DashboardHomeUsers'));

const adminRoutes = [
  {
    path: '',
    name: t('others.othDashboard'),
    component: <DashboardHomeUsers />
  },
  {
    path: 'view-documents',
    name: t('labels.lblAnalyzeDocuments'),
    component: <DashboardAnalyzeDocuments />
  },
  {
    path: 'companies',
    name: t('others.othCompanies'),
    component: <DashboardCompaniesScreen />
  },
  {
    path: 'companies/:slug',
    name: t('labels.lblCompanyDetails'),
    component: <CompanyDetailsScreen />
  },
  {
    path: 'statistics',
    name: 'Statistics',
    component: <CompaniesStatisticsScreen />
  },
  {
    path: 'companyInfo/:slug',
    name: t('labels.lblCompanyInfo') ,
    component: <CompanyInfoScreen />
  },
  {
    path: 'specialists',
    name: 'Specialists',
    component: <SpecialistsScreen />
  },
  {
    path: 'enquiry',
    name: 'Enquiry',
    component: <EnquiryScreen />
  },
  {
    path: 'registering/company',
    name: 'Registering Company',
    component: <DashboardRegisteringCompanyPage />
  },
  {
    path: 'registering/directors',
    name: 'Registering Directors',
    component: <DashboardRegisteringDirectorsPage />
  },
  {
    path: 'registering/shareholders',
    name: 'Registering Shareholders',
    component: <DashboardRegisteringShareholdersPage />
  },
  {
    path: 'registering/business',
    name: 'Registering Business',
    component: <DashboardRegisteringBusinessPage />
  },
  {
    path: 'environment-setup',
    name: t('labels.lblEnvironmentSetup'),
    component: <EnvironmentSetupScreen />
  },
  {
    path: 'payment-status',
    name: t('labels.lblPaymentStatus'),
    component: <DashboardPaymentStatus />
  }
];

export { adminRoutes };
